<template>
  <div class="md-layout">
    <md-avatar v-if="displayAvatar">
      <img
        :src="image || user.userImage || defaultImage"
        alt="Avatar"
      >
    </md-avatar>
    <div class="md-layout-item" v-if="displayLabels">
      <span class="title">{{ title || user.userDisplayName  }}</span>
      <span class="subtitle" v-if="subTitle">{{ subTitle }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'UserAvatar',
    props: {
      userId: {
        type: String,
      },
      title: {
        type: String,
      },
      subTitle: {
        type: String,
      },
      image: {
        type: String
      },
      displayAvatar: {
        type: Boolean,
        default: true
      },
      displayLabels: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        user: {},
        defaultImage: this.$store.state.defaultAvatar,
      }
    },
    watch: {
      userId: {
        immediate: true,
        handler (v) {
          if (v) this.getUserData(v);
        }
      },
    },
    methods: {
      getUserData(userId) {
        this.$store.dispatch("loadUser", userId)
        .then(res => {
          this.user = res;
        })
        .catch(err => {
          this.$notify({
            timeout: 5000,
            message: err.message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error"
          });
        });
      }
    }
  }
</script>
